import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import EulaStore from '../../stores/EulaStore';
import EulaActions from '../../actions/EulaActions';
import LoadScreen from '../../components/loadScreen/LoadScreen';

/*eslint-disable jsx-a11y/anchor-is-valid */
/**
 * FAQ View
 */
@connectToStores
class EulaView extends React.Component {
    static propTypes = {
        eulaStore: PropTypes.object,
        location: PropTypes.object
    };

    static getStores() {
        return [EulaStore];
    }

    static getPropsFromStores() {
        return {
            eulaStore: EulaStore.getState()
        };
    }

    static getInitialActions() {
        return [EulaActions.fetchEula];
    }

    render() {
        const {eulaStore} = this.props;
        const eula = eulaStore.eula;
        let eulaContainer = null;
        if (eula) {
            eulaContainer = (
                <div className="eula-container">
                    <h1 className="eula-title">
                        {eula.title}
                    </h1>
                    <div className="eula-body" dangerouslySetInnerHTML={{__html: eula.body}} />
                </div>
            );
        }
        return (
            <div className="eula-view-container">
                {eulaContainer}
                <LoadScreen show={eulaStore.loading} />
            </div>
        );
    }
}

export default EulaView;
